// extracted by mini-css-extract-plugin
export default {"container":"FullPizza_container__qSE4c","image":"FullPizza_image__bM4ss","header":"FullPizza_header__adtwj","price":"FullPizza_price__-Rtoa"};